import styled from 'styled-components';

export const Container = styled.div`
  font-weight: bold;
  font-size: 18px;
  color: #005e83;

  display: flex;
  align-items: center;
  justify-content: space-between;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  padding: 0 16px;
  padding: 0 16px;
`;

export const DivCenter = styled.div`
  
`;

export const DivRight = styled.div`
  display: flex;
  align-items: center;
  display: flex;
  align-items: center;
`;

export const DivRightItens = styled.div`
  display: flex;
`;

export const PhoneDiv = styled.div`
  display: flex;
`;

export const ManualDiv = styled.div`
  display: flex;
  padding: 0px 35px;
`;
